// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"195":"168b75121f9ba2b8","586":"eeeae9b63cfdace2","633":"be54576ef091ec3f","980":"cab3b5de5652d25e"}[chunkId] + ".css";
};